<!-- ═══════════════════════════════════════════════
     Modal 1 – Choix du rôle
═══════════════════════════════════════════════ -->
<div class="modal fade" id="loginModal" tabindex="-1" aria-labelledby="loginModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered lk-dialog-sm">
    <div class="modal-content lk-card">

      <!-- Accent bar -->
      <div class="lk-accent-bar"></div>

      <!-- Close -->
      <button type="button" class="lk-close" data-bs-dismiss="modal" aria-label="Close">
        <i class="fas fa-times"></i>
      </button>

      <!-- Header -->
      <div class="lk-header">
        <h2 class="lk-title" id="loginModalLabel">{{ 'LOGIN_MODAL.TITLE' | translate }}</h2>
        <p class="lk-subtitle">Sélectionnez votre profil pour continuer</p>
      </div>

      <!-- Role options – horizontal cards -->
      <div class="lk-options-row">

        <div class="lk-option" (click)="selectRoleAndOpenLogin('../../../../../assets/img/image1.png')">
          <div class="lk-option-img lk-opt-educator">
            <img src="../../../../../assets/img/image1.png" alt="Formatrice">
          </div>
          <span class="lk-option-label">{{ 'LOGIN_MODAL.OPTION_EDUCATOR' | translate }}</span>
        </div>

        <div class="lk-option" (click)="selectRoleAndOpenLogin('../../../../../assets/img/image2.png')">
          <div class="lk-option-img lk-opt-parent">
            <img src="../../../../../assets/img/image2.png" alt="Parent">
          </div>
          <span class="lk-option-label">{{ 'LOGIN_MODAL.OPTION_PARENT' | translate }}</span>
        </div>

        <div class="lk-option" (click)="selectRoleAndOpenLogin('../../../../../assets/img/image3.png')">
          <div class="lk-option-img lk-opt-director">
            <img src="../../../../../assets/img/image3.png" alt="Directeur">
          </div>
          <span class="lk-option-label">{{ 'LOGIN_MODAL.OPTION_DIRECTOR' | translate }}</span>
        </div>

      </div>

    </div>
  </div>
</div>

<!-- ═══════════════════════════════════════════════
     Modal 2 – Formulaire de connexion
═══════════════════════════════════════════════ -->
<div class="modal fade" id="loginModalConnecte" tabindex="-1" aria-labelledby="loginFormLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered lk-dialog-md">
    <div class="modal-content lk-form-card">

      <!-- Accent bar -->
      <div class="lk-accent-bar"></div>

      <!-- Close -->
      <button type="button" class="lk-close" data-bs-dismiss="modal" aria-label="Close">
        <i class="fas fa-times"></i>
      </button>

      <!-- Role icon badge (top-right, inside card) -->
      <div class="lk-role-badge" *ngIf="selectedImage">
        <img [src]="selectedImage" alt="Role icon">
      </div>

      <!-- Form content -->
      <div class="lk-form-body">

        <h2 class="lk-form-title" id="loginFormLabel">{{ 'LOGIN_MODAL.CONNECTED_TITLE' | translate }}</h2>
        <p class="lk-form-sub">{{ 'LOGIN_MODAL.CONNECTED_SUBTITLE' | translate }}</p>

         <!-- Inline error message (BUG-003 fix) -->
         <div class="lk-form-error" *ngIf="loginError">
           <i class="fas fa-exclamation-circle"></i> {{ loginError }}
         </div>

         <form [formGroup]="validateForm" (ngSubmit)="submitForm()" class="lk-form">

          <!-- Email -->
          <div class="lk-field">
            <label class="lk-label" for="userEmail">
              {{ 'LOGIN_MODAL.USERNAME_LABEL' | translate }}
            </label>
            <div class="lk-input-wrap">
              <i class="fas fa-envelope lk-input-icon"></i>
              <input type="text" id="userEmail" formControlName="userEmail"
                     class="lk-input" placeholder="votre@email.com">
            </div>
            <div *ngIf="validateForm.controls['userEmail'].invalid && validateForm.controls['userEmail'].touched"
                 class="lk-error">
              <i class="fas fa-exclamation-circle"></i>
              {{ 'LOGIN_MODAL.USERNAME_ERROR' | translate }}
            </div>
          </div>

          <!-- Password -->
          <div class="lk-field">
            <label class="lk-label" for="userPassword">
              {{ 'LOGIN_MODAL.PASSWORD_LABEL' | translate }}
            </label>
            <div class="lk-input-wrap">
              <i class="fas fa-lock lk-input-icon"></i>
              <input [type]="passwordVisible ? 'text' : 'password'" id="userPassword"
                     formControlName="userPassword" class="lk-input" placeholder="••••••••">
              <button type="button" class="lk-eye-btn" (click)="togglePasswordVisibility()"
                      aria-label="Afficher/Masquer le mot de passe">
                <i [class]="passwordVisible ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </button>
            </div>
          </div>
         <!-- Forgot password -->
          <div class="lk-forgot-wrap">
            <a class="lk-forgot"
               (click)="openModalAndSendRequest(validateForm.get('userEmail')?.value)">              {{ 'LOGIN_MODAL.FORGOT_PASSWORD' | translate }}
            </a>
          </div>
          <!-- Submit -->
          <button type="submit" [disabled]="loading" class="lk-btn-submit">
            <span *ngIf="!loading">
              {{ 'LOGIN_MODAL.LOGIN_BUTTON' | translate }}
              <i class="fas fa-arrow-right ms-1"></i>
            </span>
            <span *ngIf="loading" class="d-flex align-items-center gap-2">
              <i class="fas fa-spinner fa-spin"></i>
              {{ 'LOGIN_MODAL.LOGIN_BUTTON_LOADING' | translate }}
            </span>
          </button>
        </form>
      </div>
    </div>
  </div>
</div>

<app-reset-password *ngIf="isVisible" [isVisible]="isVisible" (handleVisible)="handleCancel()"></app-reset-password>
